export default {
  FIR: "Firmware-Update für RayNeo AR-Brillen",
  NO: "Firmware-Updates werden auf Mobilgeräten derzeit nicht unterstützt",
  TIPS: "Verwenden Sie für das Firmware-Update einen der folgenden Browser auf Ihrem Computer",
  pageTitle: "Firmware-Update für RayNeo AR-Brillen",
  connectStep: "Verbinden",
  updateStep: "Aktualisieren",
  supportedModels:
    "Unterstützte Modelle: RayNeo GT, RayNeo GT MAX, RayNeo Air 4 Pro, RayNeo Air 4, RayNeo Air 3s Pro, RayNeo Air 3s, RayNeo Air 3, RayNeo Air 2s, RayNeo Air 2, RayNeo Air Plus und RayNeo Air 1s.",
  desktopBrowserRequirement:
    "Verwenden Sie die Desktop-Version von Chrome oder Opera (Version 89 oder höher).",
  singleDeviceRequirement:
    "Stellen Sie sicher, dass während des Updates nur eine RayNeo-Brille mit Ihrem Computer verbunden ist.",
  displayFlickerNotice:
    "Der Bildschirm kann nach dem Anschließen der Brille kurz flackern. Dies ist normal.",
  blackScreenReminder:
    "Hinweis: Nach Abschluss des Updates bleibt das Display etwa 15 Sekunden lang schwarz, bevor es sich wieder einschaltet. Trennen Sie die Brille währenddessen nicht vom Computer.",
  connectYourGlasses: "Brille verbinden",
  connectUsbInstruction:
    "Schließen Sie Ihre Brille an einen USB-C-Anschluss Ihres Computers an und klicken Sie dann auf <strong>Brille verbinden</strong>.",
  selectDeviceInstruction:
    "Wählen Sie bei Aufforderung Ihre Brille aus der Geräteliste aus und klicken Sie auf <strong>Verbinden</strong>.",
  windowsConnectionHelp:
    "Probleme beim Verbinden von RayNeo Air Plus oder Air 1s unter Windows?",
  connectGlasses: "Brille verbinden",
  networkException:
    "Netzwerkfehler. Überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.",
  windowsRecognitionTitle: "RayNeo Air Plus und Air 1s werden nicht erkannt",
  windowsStepOne:
    "1. Drücken Sie gleichzeitig die Tasten Win + X. Klicken Sie im eingeblendeten Menü auf „Geräte-Manager“, um die Geräteliste anzuzeigen.",
  windowsStepTwo:
    '2. Wenn „STM32 DownLoad Firmware Update“ in der Geräteliste unter „Andere Geräte“ angezeigt wird, wählen Sie „STM32 Download Firmware Update“ aus, klicken Sie auf <a href="https://zadig.akeo.ie/" target="_blank" rel="noopener noreferrer">zadig</a>, um den Treiber zu installieren, und schließen Sie die Brille anschließend erneut an.',
  gotIt: "Verstanden",
  damagedFirmware:
    "Die Firmware ist beschädigt. Bitte reparieren Sie sie umgehend.",
  currentFirmwareVersion: "Aktuelle Firmware-Version: {version}",
  latestFirmwareVersion: "Sie verwenden bereits die neueste Firmware-Version.",
  newFirmwareAvailable: "Eine neue Firmware-Version ({version}) ist verfügbar.",
  details: "Details",
  newFirmwareInstructions: "Hinweise zur neuen Firmware-Version",
  noInstructions: "Derzeit sind keine Hinweise verfügbar.",
  repairFirmware: "Firmware reparieren",
  upgradeFirmware: "Firmware aktualisieren",
  popupInstruction:
    "Falls während des Updates ein Pop-up-Fenster angezeigt wird, wählen Sie darin Ihr Gerät aus und klicken Sie auf „Verbinden“.",
  fixingFirmware: "Firmware wird repariert…",
  upgradingFirmware: "Firmware wird aktualisiert…",
  doNotCloseDuringUpdate:
    "Schließen oder aktualisieren Sie diese Seite während des Updates nicht und trennen Sie Ihre Brille nicht.",
  firmwareRepairComplete: "Firmware-Reparatur abgeschlossen",
  firmwareUpdateComplete: "Firmware-Update abgeschlossen",
  firmwareCompleteDescription:
    "Ihr {model} verwendet jetzt die Firmware-Version {version}.",
  rayneoGlasses: "RayNeo-Brille",
  firmwareRepairFailed: "Firmware-Reparatur fehlgeschlagen",
  firmwareOtaUpdateFailed: "OTA-Firmware-Update fehlgeschlagen",
  retryUpdate: "Update erneut versuchen",
  repeatedProblems:
    "Wenn das Problem wiederholt auftritt, trennen Sie Ihre Brille vom Computer, aktualisieren Sie die Seite und versuchen Sie es erneut.",
  deviceDisconnected:
    "Das Gerät wurde getrennt. Überprüfen Sie die Verbindung und versuchen Sie es erneut.",
  networkError:
    "Netzwerkfehler. Überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.",
  firmwareUpdateFailedReconnect:
    "Das Firmware-Update ist fehlgeschlagen. Trennen Sie Ihre Brille vom Computer, schließen Sie sie erneut an und versuchen Sie es noch einmal.",
  firmwareUpdateFailedSelect:
    "Das Firmware-Update ist fehlgeschlagen. Wählen Sie Ihr Gerät aus und versuchen Sie es erneut.",
  firmwareDownloadAddressEmpty:
    "Die Download-Adresse für die Firmware ist leer. Das Update kann nicht durchgeführt werden.",
  firmwareUpdateRequestFailed:
    "Die Anfrage für das Firmware-Update ist fehlgeschlagen. Überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.",
  singleDeviceDuringUpdate:
    "Stellen Sie sicher, dass während des Updates nur eine RayNeo-Brille mit dem Computer verbunden ist.",
  failedGetDeviceInformation:
    "Die Geräteinformationen konnten nicht abgerufen werden ({error}). Aktualisieren Sie die Seite und versuchen Sie es erneut.",
  deviceConnectionError:
    "Fehler bei der Geräteverbindung. Trennen Sie Ihre Brille vom Computer, schließen Sie sie erneut an und versuchen Sie es noch einmal.",
  browserUnsupported: "Der aktuelle Browser unterstützt keine Firmware-Updates",
  openWithBrowsers: "Öffnen Sie diese Seite in einem der folgenden Browser",
  browserVersionGreaterThan: "Version höher als {version}",
  mobileNotSupported:
    "Firmware-Updates werden auf Mobilgeräten derzeit nicht unterstützt",
  useComputerBrowsers:
    "Verwenden Sie für das Firmware-Update einen der folgenden Browser auf Ihrem Computer",
  dfuPackageMismatch:
    "Die .dfu-Dateien im ZIP konnten den DFU-Schnittstellen des Geräts nicht zugeordnet werden. Überprüfen Sie das Firmware-Paket und das Gerät.",
  firmwareDownloadFailed:
    "Die Firmware-Datei konnte nicht heruntergeladen werden.",
};
